import FreeFieldDetailApp from "FreeFieldDefinition/detail/app";
import FreeFieldNewApp from "FreeFieldDefinition/new/app";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const freeFieldDetailRoute: RouteObject = {
  path: "freefielddetails",
  children: [{
    path: ":mainArea/new",
    loader: () => viewModel,
    Component: FreeFieldNewApp,
  }, {
    path: "detail/:key",
    loader: () => viewModel,
    Component: FreeFieldDetailApp,
  }]
};